import jwtDecode from 'jwt-decode'

export default class CurrentUser {
  constructor () {
    const token = localStorage.getItem('fonestorm-token')
    const decoded = jwtDecode(token)
    this.access = decoded.authorization.access
    this.access_rules = decoded.authorization.access_rules
    this.role = decoded.authorization.role
    this.show_messaging_brands = decoded.show_messaging_brands
  }

  // Access Rules

  subaccounts () {
    return this.access_rules.subaccounts
  }

  users () {
    return this.access_rules.users
  }

  businessObjects () {
    return this.access_rules.business_objects
  }

  fonenumbers () {
    return this.access_rules.fonenumbers
  }

  billing () {
    return this.access_rules.billing
  }

  analytics () {
    return this.access_rules.analytics
  }

  // Access

  isUser () {
    return this.access === 'User' || this.isManager()
  }

  isManager () {
    return this.access === 'Manager' || this.isAdministrator()
  }

  isAdministrator () {
    return this.access === 'Administrator'
  }

  // Role

  isLocation () {
    return this.access === 'User' || this.isOrganization()
  }

  isOrganization () {
    return this.access === 'Location' || this.isAgent()
  }

  isAgent () {
    return this.access === 'Agent' || this.isMaster()
  }

  isMaster () {
    return this.access === 'Master' || this.isFractel()
  }

  isFractel () {
    return this.access === 'FracTEL'
  }

  // Additional Features

  showMessagingBrands () {
    return this.show_messaging_brands
  }
}



// WEBPACK FOOTER //
// ./src/policy/CurrentUser.js